import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-admin";
import { connect } from "react-redux";
import {
  closeSidebarMenu,
  openSidebarMenu,
} from "../../store/actions/sideBarMenuActions";
import "./style.scss";
import {
  Home,
  Radio,
  Album,
  Podcasts,
  Login,
  LoginSharp,
  LoginOutlined,
  AdminPanelSettings,
  Add,
  Explore,
  ExploreOff,
  Close,
} from "@mui/icons-material";
import {
  Grid,
  InputAdornment,
  Input,
  Divider,
  ClickAwayListener,
} from "@mui/material";
import { useTheme } from "styled-components";
import PlayLists from "../../components/PlayLists/PlayLists";
import Scrollbar from "smooth-scrollbar";
import TouchRipple from "@mui/material/ButtonBase/TouchRipple";
import useResize from "../../hooks/resize";
import PlaylistCreateDialog from "../../components/PlaylistCreateDialog/PlaylistCreateDialog";
function SideBarNavigation({ sidebarMenu, closeMenu, openMenu }) {
  const globalStyle = useTheme();
  const itemsPaddingTop = 3;
  const media = useResize();
  const scrollContainer = useRef(null);
  const [openDialog, setOpenDialog] = useState(false);
  useEffect(() => {
    if (media === "mobile" || media === "smallMobile" || media === "tablet") {
      closeMenu();
    } else {
      openMenu();
    }
  }, [media]);
  useEffect(() => {
    Scrollbar.init(scrollContainer.current, {
      alwaysShowTracks: false,
    });
  }, []);
  useEffect(() => {
    if (sidebarMenu === "close" && scrollContainer.current !== null) {
      scrollContainer.current.parentNode.style.zIndex = 100000000;
      scrollContainer.current.parentNode.style.position = "absolute";
      scrollContainer.current.parentNode.style.transform = "translateX(-150%)";
      scrollContainer.current.parentNode.style.transition = "all 0s";
    } else if (
      (media === "smallMobile" || media === "mobile" || media === "tablet") &&
      scrollContainer.current !== null
    ) {
      scrollContainer.current.parentNode.style.transition = "all 0.5s";
      scrollContainer.current.parentNode.style.width = "100%";
      scrollContainer.current.parentNode.style.height = "100%";
      scrollContainer.current.parentNode.style.zIndex = 10000000;
      scrollContainer.current.parentNode.style.top = 0;
      scrollContainer.current.parentNode.style.left = 0;
      scrollContainer.current.parentNode.style.position = "fixed";
      scrollContainer.current.parentNode.style.transform = "translateX(0%)";
    } else {
      scrollContainer.current.parentNode.style.transition = "all 0.5s";
      scrollContainer.current.parentNode.style.zIndex = 10000000;
      scrollContainer.current.parentNode.style.position = "relative";
      scrollContainer.current.parentNode.style.transform = "translateX(0%)";
    }
  });

  return (
    <div
      ref={scrollContainer}
      style={{
        backgroundColor: "black",
        width: "100%",
        height: `calc(100vh - ${globalStyle.footer.height})`,
      }}>
      <Close
        style={{
          display:
            media === "smallMobile" || media === "mobile" || media === "tablet"
              ? "block"
              : "none",
        }}
        color="white"
        onClick={() => closeMenu()}
      />
      <aside class="left-aside" style={{ padding: "8px" }}>
        <Grid container alignItems={"center"}>
          <Grid sm={10} md={10} lg={10}>
            <h1>Valamusic</h1>
          </Grid>
          <Grid sm={2} md={2} lg={2}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="23"
              height="6"
              viewBox="0 0 23 6">
              <circle
                id="Ellipse_29"
                data-name="Ellipse 29"
                cx="3"
                cy="3"
                r="3"
                fill="#fff"
              />
              <circle
                id="Ellipse_30"
                data-name="Ellipse 30"
                cx="3"
                cy="3"
                r="3"
                transform="translate(9)"
                fill="#fff"
              />
              <circle
                id="Ellipse_31"
                data-name="Ellipse 31"
                cx="3"
                cy="3"
                r="3"
                transform="translate(17)"
                fill="#fff"
              />
            </svg>
          </Grid>
        </Grid>
        <Input
          placeholder="search..."
          style={{
            color: "white",
            borderRadius: "4px",
          }}
        />
        <ul style={{ padding: 0, width: "100%" }}>
          <Grid container direction={"column"}>
            <Link to="/">
              <Grid
                paddingTop={itemsPaddingTop}
                container
                alignItems={"center"}
                justifyContent={"start"}>
                <Grid md={4} lg={2}>
                  <Home style={{ color: "white" }} />
                </Grid>
                <Grid md={8} lg={10}>
                  <span style={{ color: "white" }}>Home</span>
                </Grid>
              </Grid>
            </Link>
            <Link to="discover">
              <Grid
                paddingTop={itemsPaddingTop}
                container
                alignItems={"center"}
                justifyContent={"start"}>
                <Grid md={4} lg={2}>
                  <Explore style={{ color: "white" }} />
                </Grid>
                <Grid md={8} lg={10}>
                  <span style={{ color: "white" }}>Explore</span>
                </Grid>
              </Grid>
            </Link>
            <Link>
              <Grid
                paddingTop={itemsPaddingTop}
                container
                alignItems={"center"}
                justifyContent={"start"}>
                <Grid md={4} lg={2}>
                  <Podcasts style={{ color: "white" }} />
                </Grid>
                <Grid md={8} lg={10}>
                  <span style={{ color: "white" }}>Podcasts</span>
                </Grid>
              </Grid>
            </Link>
            <Link to={"register"}>
              <Grid
                paddingTop={itemsPaddingTop}
                container
                alignItems={"center"}
                justifyContent={"start"}>
                <Grid md={4} lg={2}>
                  <Radio style={{ color: "white" }} />
                </Grid>
                <Grid md={8} lg={10}>
                  <span style={{ color: "white" }}>Radio</span>
                </Grid>
              </Grid>
            </Link>
            <Link to={"login"}>
              <Grid
                paddingTop={itemsPaddingTop}
                container
                alignItems={"center"}
                justifyContent={"start"}>
                <Grid md={4} lg={2}>
                  <Login style={{ color: "white" }} />
                </Grid>
                <Grid md={8} lg={10}>
                  <span style={{ color: "white" }}>Login</span>
                </Grid>
              </Grid>
            </Link>
            <Link>
              <Grid
                paddingTop={itemsPaddingTop}
                container
                alignItems={"center"}
                justifyContent={"start"}>
                <Grid md={4} lg={2}>
                  <LoginOutlined style={{ color: "white" }} />
                </Grid>
                <Grid md={8} lg={10}>
                  <span style={{ color: "white" }}>LoginOutlined</span>
                </Grid>
              </Grid>
            </Link>
            <Link to={"/admin"}>
              <Grid
                paddingTop={itemsPaddingTop}
                container
                alignItems={"center"}
                justifyContent={"start"}>
                <Grid md={4} lg={2}>
                  <AdminPanelSettings style={{ color: "white" }} />
                </Grid>
                <Grid md={8} lg={10}>
                  <span style={{ color: "white" }}>Admin</span>
                </Grid>
              </Grid>
            </Link>
          </Grid>
        </ul>
        <Divider
          height={2}
          style={{
            width: "100%",
            height: "0.8px",
            marginTop: "18px",
            backgroundColor: "#4e4e4e",
          }}
        />
        <Grid container alignItems="center" sx={{ pl: 1 }}>
          <Grid xs={9} sm={9} md={9} lg={9} xl={9}>
            <h4 style={{ display: "inline-block" }}>PlayLists</h4>
          </Grid>
          <Grid xs={3} sm={3} md={3} lg={3} xl={3}>
            <Add
              onClick={() => {
                setOpenDialog((prevState) => !prevState);
              }}
            />
            <PlaylistCreateDialog open={openDialog} setOpen={setOpenDialog} />
          </Grid>
        </Grid>
        <PlayLists />
      </aside>
    </div>
  );
}
const mapStateToProps = (state, ownProps) => {
  return {
    sidebarMenu: state.sidebarMenu,
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    closeMenu: () => {
      dispatch(closeSidebarMenu());
    },
    openMenu: () => {
      dispatch(openSidebarMenu());
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SideBarNavigation);
